import { render, staticRenderFns } from "./EditNominee.vue?vue&type=template&id=0deb7b48&scoped=true"
import script from "./EditNominee.vue?vue&type=script&lang=js"
export * from "./EditNominee.vue?vue&type=script&lang=js"
import style0 from "./EditNominee.vue?vue&type=style&index=0&id=0deb7b48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0deb7b48",
  null
  
)

export default component.exports